export const categories = [
  { id: 'all', name: '全部', slug: 'all', icon: 'ri-grid-line' },
  { id: 'romance', name: '恋爱', slug: 'romance', icon: 'ri-heart-line' },
  { id: 'fantasy', name: '奇幻', slug: 'fantasy', icon: 'ri-magic-line' },
  { id: 'school', name: '校园', slug: 'school', icon: 'ri-book-open-line' },
  { id: 'action', name: '动作', slug: 'action', icon: 'ri-sword-line' },
  { id: 'mystery', name: '悬疑', slug: 'mystery', icon: 'ri-search-eye-line' },
  { id: 'comedy', name: '搞笑', slug: 'comedy', icon: 'ri-emotion-laugh-line' },
  { id: 'drama', name: '剧情', slug: 'drama', icon: 'ri-film-line' },
];